module.exports = __webpack_public_path__ + "img/i18n.ba71742a.png";